<template>
  <div class="content" v-loading="loading">
    <div class="con-body">
      <el-table :data="tableData">
        <el-table-column prop="number" label="设备编号"></el-table-column>
        <el-table-column prop="type" label="报警类型">
          <template slot-scope="scope">{{ arrType[scope.row.type] }}</template>
        </el-table-column>
        <el-table-column prop="content" label="报警内容"></el-table-column>
        <el-table-column prop="date" label="日期"></el-table-column>
        <el-table-column prop="ste" label="状态">
          <template slot-scope="scope"
            ><span :style="{ color: arrSteColor[scope.row.ste] }">{{
              arrSte[scope.row.ste]
            }}</span></template
          >
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              class="w100"
              size="medium"
              type="primary"
              @click="ChangeSte(scope.row.id)"
              v-if="scope.row.ste == 0"
              >处理状态</el-button
            >
            <el-button class="w100" size="medium" type="info" v-else>已处理</el-button>
            <el-button size="medium" type="danger" @click="delItem(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import warningApi from "@/api/light/warning";
export default {
  data() {
    return {
      arrSte: ["未处理", "已处理"],
      arrSteColor: ["#F56C6C", "#67C23A"],
      arrType: ["", "电压", "电流", "路灯故障", "离线"],
      loading: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
    };
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      warningApi.warningList(this.pageInfo).then((res) => {
        // console.log('warningList',res.data.data)
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          warningApi.warningDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    ChangeSte(id) {
      warningApi.warningUpdate(id).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("处理成功");
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>

<style scoped>
.new-warning {
  display: inline-block;
  margin-top: 20px;
}
.pointer {
  cursor: pointer;
}
.lamp-refresh {
  top: -10px;
}
</style>
